<template>

  <form method="post" @submit.prevent="handleSubmit" ref="insuranceForm">

  <RadioGroup v-model="selected" class="py-4 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4">
    <RadioGroupOption as="template" v-for="insurance in options" :key="insurance.id" :value="insurance"
      :aria-label="insurance.title" :aria-description="`${insurance.short} for ${insurance.price}`"
      v-slot="{ active, checked }">
      <div
        :class="[checked ? 'border-transparent' : 'border-gray-300', active ? 'ring-2 ring-secondary-500' : '', 'relative flex cursor-pointer rounded-lg border bg-white p-4 shadow-sm focus:outline-none']">
        <span class="flex flex-col justify-between w-full">
          <span class="flex flex-col">
            <span class="block text-sm font-medium text-gray-900">{{ insurance.title }}</span>
            <span class="mt-1 flex items-center text-sm text-gray-500">{{ insurance.short }}</span>
          </span>
          <span class="mt-6 text-sm font-medium text-gray-900">{{ $n(insurance.price, 'currency') }} </span>
        </span>
        <CheckCircleIcon v-if="checked || active" class="size-5 text-secondary-600" aria-hidden="true" />
        <span
          :class="[active ? 'border' : 'border-2', checked ? 'border-secondary-500' : 'border-transparent', 'pointer-events-none absolute -inset-px rounded-lg']"
          aria-hidden="true" />
      </div>
    </RadioGroupOption>
  </RadioGroup> 
  </form>
  <NextButton :onNext="handleSubmit" :onPrev="onCancel" :canProceed="canProceed" />
</template>  

<script>
import { RadioGroup, RadioGroupOption } from '@headlessui/vue';
import { CheckCircleIcon } from '@heroicons/vue/20/solid';
import NextButton from './NextButton.vue';

export default {
  props: {
    onNext: {
      type: Function,
      default: () => () => { }
    },
    onCancel: {
      type: Function,
      default: () => () => { }
    },
    order: {
      type: Object,
      default: () => ({})
    },

    settings: {
      type: Object,
      default: () => ({})
    },
  },
  computed: {
    options() {
      return this.order.getInsuranceOptions(this.settings);
    },
    selectedInsurance: {
      get() {
        return this.selected;
      },
      set(value) {
        this.selected = value;
      }
    }
  },
  methods: {
    canProceed() {
      return this.selected != null;
    },
   handleSubmit() {

   
      this.order.setInsurance(this.selectedInsurance);
      if (this.onSuccess) {
        this.onNext();
      }
      return true;
    },
  },
  components: {
    RadioGroup,
    RadioGroupOption,
    CheckCircleIcon,
    NextButton
  },
  mounted() {
    this.$refs.insuranceForm.checkValidity = this.validateForm;
  },
  
  data() {
    return {
      selected: null, // Initialize with selectedInsurance prop
    };
  },


  watch: {
    selected(newVal) {
      //this.$emit("update", newVal);
      this.order.setInsurance(newVal);
    },
    selectedInsurance: {
      handler(newVal) {
        this.selected = newVal;
      },
      immediate: true,
      //      deep: true
    }
  }
};
</script>

<style scoped>
/* Add any necessary styles here */
</style>